import React from 'react';
import { Section } from './Section';
import { Bell, MapPin, Heart, Youtube } from 'lucide-react';
const benefits = [{
  icon: Bell,
  text: 'No perderte nuevas sesiones'
}, {
  icon: MapPin,
  text: 'Tener un lugar fijo para volver a ese sonido'
}, {
  icon: Heart,
  text: 'Apoyar un proyecto independiente de música en vivo'
}];
export function WhySubscribe() {
  return <Section className="relative" data-id="element-94">
      <div className="absolute inset-0 bg-amber-500/5 rounded-[3rem] -z-10 blur-3xl" data-id="element-95"></div>

      <div className="max-w-4xl mx-auto bg-surface border border-amber-500/20 rounded-[2.5rem] p-8 md:p-16 text-center shadow-[0_0_50px_rgba(212,168,83,0.05)]" data-id="element-96">
        <h2 className="text-3xl md:text-5xl font-serif mb-6" data-id="element-97">
          Por qué suscribirte
        </h2>
        <p className="text-xl text-gray-300 mb-12" data-id="element-98">
          Suscribiéndote a PampaNation, te asegurás:
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-99">
          {benefits.map((benefit, idx) => <div key={idx} className="flex flex-col items-center text-center" data-id="element-100">
              <div className="w-16 h-16 rounded-full bg-amber-500/10 flex items-center justify-center mb-6" data-id="element-101">
                <benefit.icon className="w-8 h-8 text-amber-400" data-id="element-102" />
              </div>
              <p className="text-gray-200 font-medium leading-relaxed" data-id="element-103">
                {benefit.text}
              </p>
            </div>)}
        </div>

        <a href="https://www.youtube.com/@PampaNation?sub_confirmation=1" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 bg-amber-500 hover:bg-amber-400 text-background font-bold text-lg px-10 py-5 rounded-full transition-all duration-300 hover:scale-105 hover:shadow-[0_0_30px_rgba(212,168,83,0.3)]" data-id="element-104">
          <Youtube className="w-6 h-6" data-id="element-105" />
          Suscribirme a PampaNation
        </a>
      </div>
    </Section>;
}